export enum QuotesSortProperty {
  Customer = 'contact.name',
  Date = 'issueDate',
  DueDate = 'dueDate',
  EstimateNumber = 'invoiceNo',
  ExcludedVat = 'netTotal',
}
